<template>
  <VueTypeaheadBootstrap
    v-model="search"
    @hit="handleSelect"
    :data="planos"
    :serializer="(item) => item.nome"
    :placeholder="placeholder"
    :class="[stateClass]"
    :showOnFocus="true"
    :max-matches="maxMatches"
    :size="size"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions, mapState } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import { modelValue } from "@/mixins/modelValue";
import find from "lodash/find";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {
      type: [String, Number, Object],
      default: null,
    },
    return_object: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Selecione uma plano",
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin, modelValue("value", "change")],
  props,
  data: () => ({
    search: "",
    input_value: null,
    isMounted: false,
    planos: [],
  }),
  computed: {
    ...mapState("planos", ["pagination"]),
    maxMatches() {
      const total = Number(this.pagination?.total) || 0;
      const perPage = Number(this.pagination?.per_page) || 0;

      if (total > perPage) return total;

      return perPage || 20;
    },
  },
  methods: {
    ...mapActions("planos", ["ActionGetAll"]),
    setById(id) {
      const selected = find(this.planos, { id: id });

      if (!selected) return;
      this.search = selected.nome;
      this.$emit("isConsultor", selected?.plano_consultor === 1);
    },
    handleSelect($event) {
      if (this.return_object) {
        this.modelValue = $event;
        return;
      }

      this.modelValue = $event.id;
      this.$emit("isConsultor", $event?.plano_consultor === 1);
    },
  },
  watch: {
    search: function (value) {
      if (value !== "") return;
      this.$emit("input", null);
    },
    modelValue: function (value) {
      this.setById(value);
    },
  },
  async created() {
    this.planos = await this.ActionGetAll();

    if (!this.value) return;
    this.setById(this.value);
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0;
  padding-left: 0;
  padding-top: 0;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}
</style>
